import { from, of, combineLatest, timer, merge, EMPTY, animationFrames, interval } from 'rxjs'
import { map, filter, share, switchMap, mergeMap, catchError, startWith, debounceTime, delay, tap, scan, concatMap, take, takeUntil, withLatestFrom } from 'rxjs/operators'
import Dispatch from '../Dispatcher'

const scaleMax = 300
const scaleMin = 10
//const songLength = 180000

// Every 1 second
//const seconds = songLength / 1000
//const secondsArray = new Array(parseInt(seconds))

Dispatch.nextState('view', {
  elapsed: 0,
  scale: {
    percentScale: .2
  },
  speed: 1,
  playing: false,
  mode: 'options',
  //songLength,
  groups: [
    {
      id: 'everything',
      style: ' bg-dark-green white ',
      name: 'Lights: All',
      index: 0
    },
    {
      id: 'outer',
      style: ' bg-purple white ',
      name: 'Lights: Outer Square',
      index: 1
    },
    {
      id: 'outersides',
      style: ' bg-purple white ',
      name: 'Lights: Outer Square By Side',
      index: 2
    },
    {
      id: 'square',
      style: ' bg-dark-pink white ',
      name: 'Lights: Inner Square',
      index: 3,
    },
    {
      id: 'left',
      style: ' bg-dark-red white ',
      name: 'Lights: Left Outer Square',
      index: 4,
    },
    {
      id: 'right',
      style: ' bg-dark-blue white ',
      name: 'Lights: Right Outer Square',
      index: 5
    },
  ],
  types: [
    {
      id: 'spiral',
      icon: 'faSolarSystem',
      name: 'Spiral',
      index: 0
    },
    {
      id: 'flash',
      icon: 'faFire',
      name: 'Flash',
      index: 1
    },
    {
      id: 'twinkle',
      icon: 'faSparkles',
      name: 'Twinkle',
      index: 2
    },
  ],
  special: [
    {
      id: '',
      name: 'Modifier: None',
      index: 0
    },
    {
      id: 'odd',
      name: 'Modifier: Odd Numbered Lights',
      index: 1
    },
    {
      id: 'even',
      name: 'Modifier: Even Numbered Lights',
      index: 2
    },
  ],
  visual: true
})

Dispatch.nextAction('start')

// merge(Dispatch.getAction('start'), Dispatch.getAction('pause'))
//     .pipe(
//       withLatestFrom(Dispatch.getState('view.playing')),
//       map(e => !e[1]),
//       startWith(false)
//     )
    merge(Dispatch.getAction('pause'))
      .pipe(
        map(e => false)
      )
    .subscribe(e => Dispatch.nextState('view.playing', e))

  Dispatch.getAction('thumb.details')
      .pipe(

      )
      .subscribe(e => Dispatch.nextState('view.details.selected.id', e))


combineLatest( Dispatch.getState('view.scale.percentScale'), Dispatch.getState('view.songLength'))
  .pipe(
    map(([percentScale, songLength]) => {
      const windowScale = (percentScale * scaleMax) / scaleMin
      const windowWidth = songLength/windowScale
      return ({
        percentScale,
        songLength,
        windowWidth: windowWidth,
        tickPadding: windowWidth / (songLength / 1000)
      })
    })
  )
  .subscribe(e => Dispatch.nextState('view.scale', e))

// // Selected Command
// combineLatest(Dispatch.getState('layers'), Dispatch.getState('view.details.selected.id'))
//   .pipe(
//     map(([layers, selected]) => _.find(layers, command => command.id === selected)),
//   )
//   .subscribe(e => Dispatch.nextState('view.selectedCommand'))
// const windowWidth = scale
//   .pipe(
//     map(e => songLength/e)
//   )

//   const tickPadding = windowWidth
//   .pipe(
//     map(e => e / seconds)
 // )

  // Dispatch.getAction('setElapsed')
  // .pipe(
  //   withLatestFrom(windowWidth),
  //   map(e => (e[0] / e[1]) * songLength),
  // )
  // .subscribe(e => Dispatch.nextState('view.elapsed', e))

  window.addEventListener('keydown', function(e) {
    if(e.keyCode === 32 && e.target == document.body) {
      e.preventDefault();
    }
  });


  window.addEventListener('keydown', function(e) {
    if(e.keyCode === 8 ) {
      Dispatch.getState('view.visual')
        .pipe(
          take(1),
          filter(e => e),
          withLatestFrom(Dispatch.getState('view.details.selected.id')),
          map(e => e[1]),
        )
      .subscribe(f => Dispatch.nextAction('thumb.delete', f))
    }
  });

  document.body.onmousedown = function(e) {
    Dispatch.nextState('view.mouseDown', 1)
}
document.body.onmouseup = function(e) {
  Dispatch.nextState('view.mouseDown', 0)
}